const Results_Colums=[
    {
        key:"1",
        title:"Compared Samples",
        dataIndex:"Compared Samples",
        align:"center",
    },
    {
        key:"2",
        title:"Num. of Total Ident",
        dataIndex:"num_of_total_ident",
        align:"center",
    },
    {
        key:"3",
        title:"Num. of total Sig.",
        dataIndex:"num_of_total_sig",
        align:"center",
    },
    {
        key:"4",
        title:"Num. of Sig.Up",
        dataIndex:"num_of_sigup",
        align:"center",
    },
    {
        key:"5",
        title:"Num. of Sig.Down",
        dataIndex:"num_of_sigdown",
        align:"center",
    }
]
export default Results_Colums